/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdDropdownMenuProps } from './type';
const props: TdDropdownMenuProps = {
  /** 自定义箭头图标 */
  arrowIcon: {
    type: null,
    value: 'caret-down-small',
  },
  /** 是否在点击遮罩层后关闭菜单 */
  closeOnClickOverlay: {
    type: Boolean,
    value: true,
  },
  /** 动画时长 */
  duration: {
    type: null,
    value: 200,
  },
  /** 是否显示遮罩层 */
  showOverlay: {
    type: Boolean,
    value: true,
  },
  /** 菜单栏 z-index 层级 */
  zIndex: {
    type: Number,
    value: 11600,
  },
};

export default props;
